/* eslint-disable no-nested-ternary */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import Moment from 'moment';
import PanelPrincipal from './detalle-eurovips/paquete-detalle-panel-comprar/paquete-detalle-panel-comprar';
import Transporte from './detalle-eurovips/paquete-detalle-transporte/paquete-detalle-transporte';
import Hoteles from './detalle-eurovips/paquete-detalle-hoteles/paquete-detalle-hoteles';
import VacacionesAMedida from './paquete-detalle-vacaciones-medida/paquete-detalle-vacaciones-medida';
import Incluye from './detalle-eurovips/paquete-detalle-incluye/paquete-detalle-incluye';
import InformacionAdicional from './detalle-eurovips/paquete-detalle-informacion-adicional/paquete-detalle-informacion-adicional';
import Salida from '../paquetes-lista/salida';
import Panel from './panel/panel';
import PanelOperador from './panel-operador/panel-operador';
import VerFinanciacion from '../../commons/ver-financiacion';

class Detalle extends Component {
  constructor(props) {
    super(props);
    this.formatearPrecio = this.formatearPrecio.bind(this);
    this.armarSalidas = this.armarSalidas.bind(this);
    this.armarDescripcionMeta = this.armarDescripcionMeta.bind(this);
  }

  formatearPrecio(precioNeto, impuestos, iva, cantPasajeros) {
    let precioRedondeado = 0;
    if (cantPasajeros > 0) {
      precioRedondeado = Math.ceil(
        (precioNeto + impuestos + iva) / cantPasajeros,
      );
    } else {
      precioRedondeado = Math.ceil(precioNeto + impuestos + iva);
    }

    return this.formatNumber(precioRedondeado);
  }

  formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  armarSalidas() {
    const listaSalidas = [];

    if (this.props.salidas) {
      for (let i = 0; i <= this.props.salidas.length - 1; i++) {
        if (this.props.salidaNoVisible !== i) {
          listaSalidas.push(
            <Salida
              proveedorId={this.props.proveedorId}
              distribucion={this.props.distribucion}
              indice={i}
              salidas={this.props.salidas}
              formatearPrecio={this.formatearPrecio}
              cant_pasajeros={
                this.props.paquete.pasajeros !== null
                  ? this.props.paquete.pasajeros.length
                  : this.props.cantidadPasajeros
              }
              key={i}
              hoteles={this.props.salidas[i].hoteles}
              datos={this.props.salidas[i]}
            />,
          );
        }
      }
    }
    return listaSalidas;
  }

  armarDescripcionMeta() {
    const cantPasajeros
            = this.props.paquete.pasajeros !== null ? this.props.paquete.pasajeros.length > 0 ? this.props.paquete.pasajeros.length : this.props.cantidadPasajeros : '1';

    const precio = this.formatearPrecio(
      this.props.paquete.salidas[0].precios.precioNeto,
      this.props.paquete.salidas[0].precios.impuestos,
      this.props.paquete.salidas[0].precios.iva,
      cantPasajeros,
    );

    const fechaSalida = Moment(this.props.paquete.salidas[0].fechaSalida).format(
      'DD/MM/YYYY',
    );

    return `ARS ${precio} - Fecha de salida ${fechaSalida}`;
  }

  renderizarDetalle() {
    const cantPasajeros
      = this.props.paquete.pasajeros !== null ? this.props.paquete.pasajeros.length > 0 ? this.props.paquete.pasajeros.length : this.props.cantidadPasajeros : '1';

    const precio = (this.props.paquete.salidas[0].precios.precioNeto + this.props.paquete.salidas[0].precios.impuestos + this.props.paquete.salidas[0].precios.iva) / cantPasajeros;

    return (
      <div className='listado-paquetes'>
        {/* <Helmet>
          <meta property="og:title" content={ this.props.paquete.nombre }/>
          <meta property="og:description" content={ this.armarDescripcionMeta() }/>
          <meta property="og:image" content={ this.props.paquete.imagen }/>
          <meta property="og:url" content={ isClient ? window.location.href : '' }/>
          <meta property="og:type" content="website" />
        </Helmet> */}
        <div className='detalle paquete'>
          <PanelPrincipal
            proveedorId={this.props.proveedorId}
            distribucion={this.props.distribucion}
            paquete={this.props.paquete}
            referencia={this.props.referencia}
            formatearPrecio={this.formatearPrecio}
            cantidadPasajeros={this.props.cantidadPasajeros}
          />
          {this.props.salidas !== undefined ? (
            <div>
              <div
                className='panel-heading collapsed'
                data-toggle='collapse'
                data-parent='#accordion'
                href='#collapseThree'
                role='tab'
                id='headingThree'
              >
                <h4 className='panel-title'>
                  <a
                    style={{ fontWeight: '400!important' }}
                    className='collapsed  accordion-toggle'
                    role='button'
                    data-toggle='collapse'
                    data-parent='#accordion'
                    href='#collapseThree'
                    aria-expanded='false'
                    aria-controls='collapseThree'
                  >
                    Ver más Salidas
                  </a>
                </h4>
              </div>

              <div
                id='collapseThree'
                className='panel-collapse collapse salidas panel paquete'
                role='tabpanel'
                aria-labelledby='headingThree'
              >
                <div className='panel-body'>{this.armarSalidas()}</div>
              </div>
            </div>
          ) : null}
          <div className='container'>
            <div className='seccion'>
              <VerFinanciacion
                id={this.props.paquete.idProducto}
                price={precio}
                appId={this.props.paquete.applicationId}
              />

              {/* <PanelPromo */}
              {/* proveedorId={this.props.proveedorId} */}
              {/* precio={this.props.paquete.salidas[0].precios.precioNeto} */}
              {/* impuesto={this.props.paquete.salidas[0].precios.impuestos} */}
              {/* cantidadPasajeros={this.props.cantidadPasajeros} */}
              {/* /> */}
            </div>
            <br />
            <br />
            <Transporte
              transporte={this.props.paquete.salidas[0].transporte}
              ida={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeIda}
              vuelta={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeVuelta}
            />

            <Panel titulo='Servicios'>
              <div className='col-lg-2 col-md-3 col-sm-12'>
                <div className='contenedor icono-servicio  text-center'>
                  <span className='color-dinamico icono fa fa-plane' />
                  <span className='descripcion'>Aéreo</span>
                </div>
              </div>
              <div className='col-lg-2 col-md-3 col-sm-12'>
                <div className='contenedor icono-servicio  text-center'>
                  <span className='color-dinamico icono fa fa-bed' />
                  <span className='descripcion'>Hotel</span>
                </div>
              </div>
              <div className='col-lg-2 col-md-3 col-sm-12'>
                <div className='contenedor icono-servicio  text-center'>
                  <span className='color-dinamico icono fa fa-car' />
                  <span className='descripcion'>Traslados</span>
                </div>
              </div>
              <div className='col-lg-2 col-md-3 col-sm-12'>
                <div className='contenedor icono-servicio  text-center'>
                  <span className='color-dinamico icono fa fa-medkit' />
                  <span className='descripcion'>Seguro</span>
                </div>
              </div>
            </Panel>

            <Hoteles
              destinos={this.props.paquete.salidas[0].destinosHoteles}
              hoteles={this.props.paquete.salidas[0].hoteles}
            />
            <VacacionesAMedida
              referencia={this.props.referencia}
              proveedorId={this.props.proveedorId}
              destino={this.props.paquete.salidas[0].destinoIata}
              fechaSalida={this.props.paquete.salidas[0].fechaSalida}
              cantidadNoches={this.props.paquete.cantNoches}
            />
            {this.props.paquete.metaDescripcion !== null && (
              <Incluye descripcion={this.props.paquete.metaDescripcion} />
            )}
            <InformacionAdicional
              titulo={this.props.paquete.nombre}
              observaciones={this.props.paquete.salidas[0].observaciones}
            />
            <PanelOperador
              datos={this.props.paquete.operadorResponsable}
            />
          </div>
          <div className='clearfix' />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.props.paquete !== undefined ? this.renderizarDetalle() : ''}
      </div>
    );
  }
}
export default Detalle;
